module.exports = __webpack_public_path__ + "3785e0f7a4488fab86cc4a886ca9a3f1.woff";